export default "__VITE_ASSET__c865a2c7__"